// extracted by mini-css-extract-plugin
module.exports = {"modalWrapper":"FormModal_modalWrapper__5pH6F","modalBackdrop":"FormModal_modalBackdrop__5PefN","formTabsContainer":"FormModal_formTabsContainer__nXuN1"};